import { Card, CardContent, CardHeader, CardTitle, LoadingSpinner, QueryErrorAlert } from '@shared/components';
import type { HistoryPage } from '../types/agreementTimeline.types';
import { AgreementHistoryTimeline } from './AgreementHistoryTimeline';

interface Props {
    isLoading: boolean;
    isError: boolean;
    history: HistoryPage | undefined;
    currentPage: number;
    onRetry: () => void;
    onPageChange: (page: number) => void;
}

const headingId = 'agreement-history-heading';

/** History is fetched independently of the Agreement, so a failed or slow
 *  history fetch must not blank the page. */
export function AgreementHistoryTab({ isLoading, isError, history, currentPage, onRetry, onPageChange }: Props) {
    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <span id={headingId}>History</span>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <section aria-labelledby={headingId}>
                    <HistoryBody
                        isLoading={isLoading}
                        isError={isError}
                        history={history}
                        currentPage={currentPage}
                        onRetry={onRetry}
                        onPageChange={onPageChange}
                    />
                </section>
            </CardContent>
        </Card>
    );
}

function HistoryBody({ isLoading, isError, history, currentPage, onRetry, onPageChange }: Props) {
    if (isLoading) {
        return <LoadingSpinner message="Loading history" />;
    }

    if (isError || !history) {
        return (
            <QueryErrorAlert message="Failed to load the agreement's history." onRetry={onRetry} />
        );
    }

    return <AgreementHistoryTimeline history={history} currentPage={currentPage} onPageChange={onPageChange} />;
}
